export const EDIT_MODE = {
  edit: 1,
  add: 0,
};
